import { createFileRoute } from "@tanstack/react-router";
import { DEFAULT_COMPANY, isCompanyId } from "../prototype/fixtures";
import { NewBillScreen } from "../screens/BillsScreen";

export const Route = createFileRoute("/prototype/c/$companyId/purchases/bills/new")({
  component: NewBill,
});

function NewBill() {
  const { companyId } = Route.useParams();
  return <NewBillScreen companyId={isCompanyId(companyId) ? companyId : DEFAULT_COMPANY} />;
}
